import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Spinner } from "@/components/ui/spinner";

import HeatMapChart, { HeatMapChartProps } from ".";

export interface HeatMapChartCardProps extends HeatMapChartProps {
  title: string;
  loading?: boolean;
}

const HeatMapChartCard = ({
  title,
  loading,
  ...chartProps
}: HeatMapChartCardProps) => {
  return (
    <Card className="relative">
      <CardHeader className="p-2">
        <CardTitle
          className="text-xs md:text-sm text-center"
          data-testid="title"
        >
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col items-center">
        <Separator className="mb-2" />
        <HeatMapChart size={"100%"} {...chartProps} />
        {chartProps?.labels && (
          <div className="flex justify-center pt-4">
            <ul className="inline-flex flex-wrap justify-center gap-x-4 gap-y-2">
              {Object.entries(chartProps?.labels).map(([color, label]) => (
                <li key={color} className="flex items-center space-x-2">
                  <span
                    className="w-3 h-3 rounded-full"
                    style={{ backgroundColor: color }}
                  />
                  <span className="text-gray-700">{label}</span>
                </li>
              ))}
            </ul>
          </div>
        )}
        {loading && (
          <div className="absolute inset-0 bg-white/75 flex items-center justify-center rounded-lg">
            <Spinner className="h-8 w-8" />
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default HeatMapChartCard;
